export default __webpack_public_path__ + "static/media/ddos.5adc9a9c.svg";